import api from "../services/api";

const path = "pontoacesso";

export const getPointsAccessForDisplay = async () => {
  return await api.get(`${path}/exibicao`);
};

export const getPointsAccess = async () => {
  return await api.get(`${path}`);
};

export const findPointAccess = async ({ id }) => {
  return await api.get(`${path}/${id}`);
};

export const editPointAccess = async ({ id, body }) => {
  return await api.put(`${path}/${id}`, body);
};

export const createPointAccess = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const deletePointAccess = async ({ id }) => {
  return await api.delete(`${path}/${id}`);
};
